import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import ManuOperation from "../operationRoom/navOperationRoom/ManuOperation";
import Pagination from "../pagination/Pagination";
import moment from "moment";
import { HashLoader } from "react-spinners";

import Input from "../material/input/Input";
import Button from "../material/button/Button";

import styles from "./InspectionGuide.module.css";
import ModalAddData from "../material/modal/ModalAddData";
import * as labApi from "../../service/labPersonalApi";

import { useLocation, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";

import { CurrentUserContext } from "../../App";

import TableSearchV1 from "../tableV1/tableSearchV1";
import { FaTrashAlt, FaEye } from "react-icons/fa";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function Document() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const nav = useNavigate();
  const location = useLocation();

  const [toggle, setToggle] = useState("document"); // document, guide
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [openModalUploadFile, setOpenModalUploadFile] = useState(false);
  const [date, setDate] = useState("");

  const [total, setTotal] = useState(null);
  const [filters, setFilters] = useState({
    document_name: "",
  });

  const [guideList, setGuideList] = useState([]);
  const [guidePage, setGuidePage] = useState(1);
  const [guideMaxPage, setGuideMaxPage] = useState(1);
  const [openModalAddData, setOpenModalAddData] = useState(false);
  const [guidelineTitle, setGuidelineTitle] = useState("");
  const [guidelineDetail, setGuidelineDetail] = useState("");
  const [showDetail, setShowDetail] = useState(false);

  const [numberIns, setNumberIns] = useState("");
  const [numberDoc, setNumberDoc] = useState("");

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
    if (location.state?.type) {
      setToggle(location.state?.type);
    }
  }, []);

  useEffect(() => {
    getDocumentList();
  }, [page, filters]);

  const getDocumentList = async () => {
    setLoading(true);
    let res = await labApi.getDocument(page, 10, filters);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setDocumentList(res["data"]["document_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setNumberDoc(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const columnsDoc = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "หัวข้อ",
      accessor: "document_name",
      Cell: ({ row }) => {
        return (
          <div
            className="cursor-pointer text-[#000000] text-left"
            onClick={() => {
              window.open(row.original.document_file);
            }}
          >
            {row.original.document_name}
          </div>
        );
      },
      Filter: "text",
      wrap: true,
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "document_id",
      Cell: ({ row }) => {
        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px]"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() => {
                window.open(row.original.document_file);
              }}
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div class="bg-[#ffffff] pb-[30px]">
      <div className={styles.blockContent}>
        <div
          className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
        >
          รายการเอกสารที่เกี่ยวข้องทั้งหมด
          <div className={styles.titleDate}>(ข้อมูลวันที่ {date})</div>
        </div>

        <div className={`${styles.detailfont} my-4`}>
          สามารถดาวน์โหลดเอกสารเพิ่มเติม เช่น แนวปฏิบัติทางเภสัชกรรมคลินิก
          สำหรับการตรวจลักษณะทางพันธุกรรม HLA-B*58:01 <br /> เพื่อประกอบการใช้ยา
          allopurinol ฉบับปรับปรุง พ.ศ. 2564 และเอกสารอื่นๆ ที่เกี่ยวข้องได้
        </div>

        <TableSearchV1
          columns={columnsDoc}
          data={documentList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={total}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
      </div>
    </div>
  );
}
export default Document;
